import { Brand } from '@axo/config/@types/Brand.types';
import { consent_api, IAPI } from '@axo/shared/data-access/api';
import { ConfigType } from '@axo/shared/data-access/types/consent';
import { MarketCountryCode } from '@axo/shared/types';

export const checkUserConsent =
  (api: IAPI) =>
  async (data: {
    country: MarketCountryCode;
    customerID: string;
    configType?: ConfigType;
    brandID?: Brand;
  }): Promise<boolean> => {
    try {
      const [userConsent, currentConsent] = await Promise.all([
        consent_api.getConsent(api)(data),
        consent_api.getConsentConfig(api)(data),
      ]);

      return userConsent?.[0]?.ConfigID === currentConsent?.[0].ID;
    } catch {
      return false;
    }
  };
